angular.module('myApp.directives')
    .directive("speechRecognitionData", function() {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
            },
            controller: function ($scope, $element, $attrs, $transclude, speechRecognitionManager) {
                speechRecognitionManager.setIsRecognizeSpeech(false);
            }
        }
    });